import { Typography, Grow } from '@material-ui/core';
import React from 'react';
import { useStyles } from './useStyles';

export const Name = () => {
	const classes = useStyles();
	return (
		<div className={classes.name}>
			<Grow in={true} timeout={1000}>
				<Typography variant="h4" color="secondary">
					NICO
					<br />
					CAPPELLA
				</Typography>
			</Grow>
		</div>
	);
};
